// ORIGINAL SOURCE leaked via source map (info disclosure).
// All secrets FAKE / vuln-lab.test. Detected by js_secrets_scan.
const ADMIN_BACKDOOR_TOKEN = 'sk_live_carol_admin_1b8e';
const DB_PASSWORD = 'P@ssw0rd123';
// TODO(before launch): remove debug endpoint /internal/debug?token=letmein
export function ping() { return { token: ADMIN_BACKDOOR_TOKEN, db: DB_PASSWORD }; }
